import React from 'react';
import { Grid } from '@material-ui/core';
import { Text } from 'library';
import { AvailabilityCategories } from './AvailabilityCategory';

export interface WhenDoYouWorkIconType {
    icon: React.ReactElement;
    headerText: string;
    subText: string;
    availabilityCategory: AvailabilityCategories;
}

export default function WhenDoYouWorkCaption({ item, color }: { item: WhenDoYouWorkIconType; color: string }) {
    return (
        <Grid container direction="column">
            <Grid item>
                <Text variant="caption" bold color={color}>
                    {item.headerText}
                </Text>
            </Grid>
            <Grid item>
                <Text variant="body3" color={color}>
                    {item.subText}
                </Text>
            </Grid>
        </Grid>
    );
}
